import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { UtilitiesProvider } from '../../providers/utilities';
import { NavController, NavParams } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { PaymentProvider } from '../../providers/payment';
import * as fromAuth from '../../ngrx/reducers/auth.reducer';
import { TranslateCodePipe } from '../../pipes/translate';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';
import { TicketData } from '../../providers/ticket';

const componentName = 'ButtonShoppingCartTicketComponent';

@Component({
  selector: 'button-shopping-cart-ticket',
  templateUrl: 'button-shopping-cart-ticket.html'
})
export class ButtonShoppingCartTicketComponent implements OnInit, OnDestroy {

  @Input() configColor: any;
  @Input() viewCartFrom: any;
  @Input() uidTrack: string;
  @Input() eventId: string = '--';
  @Input() forceView: boolean = false; // Este parametro obliga a mostrar el carrito de compra asi no existan productos agregados

  private userSubscribe: Subscription;
  public shoppingCart$: Observable<any>;

  constructor(
    private store: Store<{}>,
    private utilities: UtilitiesProvider,
    private navCtrl: NavController,
    private translatePipe: TranslateCodePipe,
    private ticketData: TicketData,
    private analytics: AnalyticsData,
    public navParams: NavParams
  ) { }

  ngOnInit() {
    this.userSubscribe = this.store.select(fromAuth.getUser)
      .subscribe(user => {
        if (user) { this.shoppingCart$ = this.ticketData.getUserShoppingCart(user.info.id); }
      });
  }

  /**
   * Carga el carrito de compra del usuario o muestra un mensaje de que no existen productos en el carrito
   * @param isEmpty
   */
  public shoppinCart(isEmpty = false) {
    if (isEmpty) { return this.utilities.presentToast('You have no products added in the shopping cart!'); }
    this.navCtrl.push('ShoppingTicketCartPage', { eventId: this.eventId });
    // TrackingAction - viewCart
    this.analytics.savePageTrackOnFirestore(
      componentName,
      _ACTIONS.viewCartCatalog,
      this.uidTrack,
      { params: this.navParams.data, viewCartFrom: this.viewCartFrom }
    );
  }

  ngOnDestroy() {
    if (this.userSubscribe) this.userSubscribe.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/button-shopping-cart-ticket/button-shopping-cart-ticket.ts